import { ExamResult, type ExamEventExamineeStatus } from '@exam-center/graphql';
import { CancelOutlinedIcon, CheckCircleOutlineRoundedIcon, Text, Chip } from '@shared/components';

export const EXAM_EVENT_EXAMINEE_STATUS_LABEL: Record<ExamEventExamineeStatus, string> = {
  ABSENT: 'Absent',
  CANCELED: 'Canceled',
  COMPLETED: 'Completed',
  FINISHED: 'Finished',
  IN_PROGRESS: 'In Progress',
  PENDING_RESULTS: 'Pending Results',
  PREPARE_FOR_EXAM: 'Prepare for Exam',
  PROCESSING: 'Processing',
  REGISTERED: 'Registered',
};

interface ExamineeMonitorStatusLabelProps {
  status: ExamResult;
}

export default function ExamineeMonitorStatusLabel({
  status,
}: Readonly<ExamineeMonitorStatusLabelProps>) {
  switch (status) {
    case ExamResult.Passed:
      return (
        <Chip
          icon={
            <CheckCircleOutlineRoundedIcon
              sx={(theme) => ({
                color: theme.palette.success.main,
                '&.MuiChip-icon': {
                  fontSize: '1rem',
                },
              })}
            />
          }
          label={
            <Text
              variant='body2Semibold'
              sx={(theme) => ({
                ml: theme.spacing(1),
                justifyItems: 'center',
              })}
            >
              Pass
            </Text>
          }
          color='success'
          variant='outlined'
          size='small'
          sx={(theme) => ({
            pl: theme.spacing(2.5),
            pr: theme.spacing(3),
            color: theme.palette.success.dark,
            borderColor: theme.palette.success.main,
            width: '76px',
          })}
        />
      );

    case ExamResult.Failed:
      return (
        <Chip
          icon={
            <CancelOutlinedIcon
              sx={(theme) => ({
                color: theme.palette.error.main,
                '&.MuiChip-icon': {
                  fontSize: '1rem',
                },
              })}
            />
          }
          label={
            <Text
              variant='body2Semibold'
              sx={(theme) => ({
                ml: theme.spacing(1),
                justifyItems: 'center',
              })}
            >
              Fail
            </Text>
          }
          color='error'
          variant='outlined'
          size='small'
          sx={(theme) => ({
            pl: theme.spacing(2.5),
            pr: theme.spacing(3),
            color: theme.palette.error.dark,
            borderColor: theme.palette.error.main,
            width: '76px',
          })}
        />
      );
    default:
      return '-';
  }
}
